import { render, staticRenderFns } from "./BaseInputHotkeys.vue?vue&type=template&id=0dc04138&"
import script from "./BaseInputHotkeys.vue?vue&type=script&lang=js&"
export * from "./BaseInputHotkeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports